// Investigator « Suivi » dashboard (subject groups / families).
export const suivi = {
  suivi_tab_label: "Suivi",
  suivi_caption_todo: "{{count}} à traiter",
  suivi_caption_uptodate: "{{count}} à jour",
  suivi_caption_all_done: "Tout est à jour · {{count}} dossiers",
  suivi_search_placeholder: "N° de dossier…",
  suivi_search_no_match: "Aucun dossier ne correspond à « {{query}} »",
  suivi_group_todo_title: "À traiter",
  suivi_group_uptodate_title: "À jour",
  suivi_up_to_date_row: "Rien à faire",
  suivi_empty: "Aucun dossier pour le moment",
  suivi_dossier: "Dossier {{code}}",
  suivi_family: "Famille",
  suivi_group_title: "Dossier",
  suivi_member_generic: "Participant",
  suivi_action_fill: "1 questionnaire à remplir",
  suivi_action_fill_plural: "{{count}} questionnaires à remplir",
  suivi_action_remind: "À relancer",
  suivi_action_remind_role: "Relancer · {{role}}",
  suivi_members: "Membres",
  suivi_to_fill: "À remplir par vous",
  suivi_parents_side: "Côté participants",
  suivi_history: "Historique",
  suivi_history_done: "{{count}} terminés",
  suivi_history_missed: "{{count}} manqués",
  suivi_done_on: "Fait le {{date}}",
  suivi_missed_on: "Fenêtre expirée · {{date}}",
  suivi_answered_by: "Répondu par {{who}}",
  suivi_answered_by_you: "vous",
  suivi_to_answer_by: "À remplir par {{who}}",
  suivi_questionnaire: "Questionnaire",
  suivi_fill: "Remplir",
  suivi_continue_progress: "Continuer {{answered}}/{{total}}",
  suivi_filled_by_colleague: "Rempli par un collègue",
  suivi_status_not_started: "Pas commencé",
  suivi_status_in_progress: "En cours {{answered}}/{{total}}",
  suivi_call: "Appeler",
  suivi_copy_number: "Copier le numéro",
  suivi_contact: "Contacter",
  suivi_copy_email: "Copier l'e-mail",
  suivi_email_copied: "E-mail copié",
  suivi_copied: "Numéro copié",
  suivi_during_call: "Pendant l'appel",
  suivi_minutes: "≈ {{count}} min",
  suivi_mark_reminded: "Marquer relancé aujourd'hui",
  suivi_reminded_on: "Relancé le {{date}}",
  suivi_empty_group: "Rien à faire pour ce dossier",
  suivi_next_window_fill: "À remplir par vous : {{label}} — s'ouvre le {{date}}",
  suivi_next_window_subject: "{{role}} : {{label}} — s'ouvre le {{date}}",
  suivi_home_next_window: "Prochaine fenêtre : le {{date}} ({{group}})",
  suivi_due_today: "Aujourd'hui",
  suivi_due_tomorrow: "Demain",
  suivi_due_in_days: "J-{{count}}",
  suivi_due_past: "Expiré",
  // « Ajouter un dossier » — investigator dossier management.
  suivi_new_dossier_button: "Nouveau dossier",
  suivi_new_dossier_title: "Nouveau dossier",
  suivi_new_dossier_description:
    "Saisissez le numéro de dossier puis la composition de la famille. Les parents pourront ensuite créer leur compte avec ce même numéro.",
  suivi_new_dossier_create: "Créer le dossier",
  suivi_dossier_numero_label: "Numéro de dossier",
  suivi_dossier_numero_required: "Le numéro de dossier est obligatoire",
  suivi_dossier_members_required: "Ajoutez au moins un membre",
  suivi_dossier_exists: "Ce dossier existe déjà",
  suivi_add_member_button: "Ajouter un membre",
  suivi_add_member_title: "Ajouter un membre",
  suivi_add_member_role_required: "Choisissez un rôle",
  suivi_add_member_confirm: "Ajouter",
  suivi_add_member_done: "Membre ajouté",
  suivi_remove_member_title: "Retirer ce membre",
  suivi_remove_member_text:
    "Retirer {{role}} de ce dossier ? Cette action n'est possible que tant qu'aucune donnée n'a été saisie.",
  suivi_remove_member_confirm: "Retirer",
  suivi_remove_member_done: "Membre retiré",
  suivi_remove_member_blocked:
    "Ce membre a déjà des données : il ne peut plus être retiré.",

  suivi_member_actions: "Actions",
  suivi_exit_member_title: "Sortie d'étude",
  suivi_exit_member_text:
    "{{name}} ne participera plus à l'étude. Les données déjà recueillies sont conservées ; aucun nouveau questionnaire ne sera créé et aucune relance ne sera envoyée.",
  suivi_exit_dossier_title: "Sortie d'étude du dossier",
  suivi_exit_dossier_text:
    "Tous les membres du dossier {{name}} sortiront de l'étude, y compris ceux rattachés à un autre centre. Les données déjà recueillies sont conservées.",
  suivi_exit_reason_label: "Motif",
  suivi_exit_reason_withdrawal: "Opposition / retrait",
  suivi_exit_reason_screen_failure: "Non éligible",
  suivi_exit_reason_lost: "Perdu de vue",
  suivi_exit_reason_error: "Erreur d'inclusion",
  suivi_exit_reason_other: "Autre",
  suivi_exit_note_label: "Précision (facultatif)",
  suivi_exit_data_label: "Données déjà recueillies",
  suivi_exit_data_keep: "Conserver",
  suivi_exit_data_drop: "Ne plus utiliser",
  suivi_exit_data_drop_warning:
    "Les données de cette personne seront retirées des exports et ne seront plus visibles. Cette action est irréversible.",
  suivi_exit_confirm: "Confirmer la sortie",
  suivi_exit_member_done: "Sortie d'étude enregistrée",
  suivi_exit_dossier_done: "Dossier sorti de l'étude",
  suivi_exit_dossier_button: "Sortie d'étude du dossier",
  suivi_exited_tag: "Sortie d'étude",
  suivi_exited_tag_reason: "Sortie d'étude · {{reason}}",

  suivi_death_title: "Déclarer un décès",
  suivi_death_text:
    "Enregistrer le décès de {{name}}. Les données sont conservées et le reste du dossier poursuit son suivi normalement.",
  suivi_death_date_label: "Date du décès (facultatif)",
  suivi_death_confirm: "Enregistrer",
  suivi_death_done: "Décès enregistré",
  suivi_death_clear_title: "Annuler le décès déclaré",
  suivi_death_clear_done: "Déclaration annulée",
  suivi_deceased_tag: "Décès",

  suivi_access_link_title: "Envoyer le lien d'accès",
  suivi_access_link_resend_title: "Renvoyer le lien d'accès",
  suivi_access_link_text:
    "{{name}} recevra un lien pour créer son compte et accéder à ses questionnaires.",
  suivi_access_link_email_label: "Adresse e-mail",
  suivi_access_link_confirm: "Envoyer",
  suivi_access_link_done: "Lien d'accès envoyé",
  suivi_access_link_unavailable:
    "Impossible d'envoyer le lien : aucun contact enregistré, ou aucune invitation configurée pour ce profil.",
  suivi_invited_on: "Invité le {{date}}",

  // « Dates de référence » — dossier rules deriving a member's anchor date (case mode).
  suivi_refdates: "Dates de référence",
  suivi_refdate_resolved: "Date retenue : {{date}}",
  suivi_refdate_waiting: "En attente — {{done}} sur {{total}}",
  suivi_refdate_deceased: "({{n}} décès)",
  suivi_refdate_missing: "Manque : {{who}}",
  suivi_refdate_missing_hidden: "{{n}} hors de votre site",
  suivi_refdate_no_source: "Aucune date source",
  suivi_refdate_no_source_death: "Aucune date source — décès",
  suivi_refdate_unconfigured: "Règle à compléter côté recherche",
  suivi_refdate_member_missing: "Date « {{label}} » manquante",

  invite_relative_menu_title: "Inviter {{role}}",
  invite_relative_menu_action: "Inviter",
  invite_relative_title: "Inviter",
  invite_relative_text:
    "La personne recevra un lien pour rejoindre votre dossier, prendre connaissance de la note d'information et créer son compte.",
  invite_relative_unavailable:
    "Aucune invitation n'est disponible pour le moment.",
  invite_relative_firstname: "Prénom",
  invite_relative_lastname: "Nom",
  invite_relative_email: "Adresse e-mail",
  invite_relative_role_required: "Choisissez qui vous souhaitez inviter.",
  invite_relative_fields_required: "Merci de compléter tous les champs.",
  invite_relative_confirm: "Envoyer l'invitation",
  invite_relative_done: "Invitation envoyée",
};
